import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { AdmAutocadastroService } from 'src/app/shared/api/adm-autocadastro.service';
import { AdmEquipeService } from 'src/app/shared/api/adm-equipe.service';
import { AdmSkinService } from 'src/app/shared/api/adm-skin.service';
import { ClientesService } from 'src/app/shared/api/clientes.service';
import { LicencasDisponiveisAdmService } from 'src/app/shared/api/licencas/licencas-disponiveis-adm.service';
import { SkinService } from 'src/app/shared/api/skins.service';
import { EditComponentModule } from 'src/app/shared/components/edit-component/edit-component.module';
import { TableListModule } from 'src/app/shared/components/table-list/table-list.module';
import { AutocadastroModule } from '../autocadastro/autocadastro.module';
import { LiberarLicencaEquipeModule } from '../equipes/liberar-licenca-equipe/liberar-licenca-equipe.module';
import { ClienteFormComponent } from './cliente-form/cliente-form.component';
import { ClientesRoutingModule } from './clientes-routing.module';
import { ClientesComponent } from './clientes.component';
import { FormsEquipesClienteComponent } from './forms-equipes-cliente/forms-equipes-cliente.component';

@NgModule({
    declarations: [ClientesComponent, ClienteFormComponent, FormsEquipesClienteComponent],
    imports: [
        CommonModule,
        ClientesRoutingModule,
        EditComponentModule,
        TableListModule,
        AutocadastroModule,
        LiberarLicencaEquipeModule
    ],
    providers: [ClientesService, AdmEquipeService, AdmSkinService, AdmAutocadastroService, SkinService, LicencasDisponiveisAdmService]
})
export class ClientesModule {}
